export default class OperationDocumentTypeModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
  }
}